import { render } from "./InstructorBio.vue?vue&type=template&id=8276a214&scoped=true"
import script from "./InstructorBio.vue?vue&type=script&lang=js"
export * from "./InstructorBio.vue?vue&type=script&lang=js"

import "./InstructorBio.vue?vue&type=style&index=0&id=8276a214&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8276a214"]])

export default __exports__